"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToDecimalPlaces = roundToDecimalPlaces;
exports.ceilToDecimalPlaces = ceilToDecimalPlaces;
exports.floorToDecimalPlaces = floorToDecimalPlaces;
/**
 * Rounds a number to specified amount of decimal places.
 *
 * @param num - The number to round
 * @param decimalPlaces - The number of decimal places to round to
 * @returns The rounded number
 *
 */
function roundToDecimalPlaces(num, decimalPlaces = 0) {
    if (decimalPlaces < 1) {
        return Math.round(num);
    }
    const multiplier = Math.pow(10, decimalPlaces);
    return Math.round(num * multiplier + Number.EPSILON) / multiplier;
}
/**
 * Ceils a number to specified amount of decimal places.
 *
 * @param num - The number to ceil
 * @param decimalPlaces - The number of decimal places to ceil to
 * @returns The ceiled number
 *
 */
function ceilToDecimalPlaces(num, decimalPlaces = 0) {
    if (decimalPlaces < 1) {
        return Math.ceil(num);
    }
    const multiplier = Math.pow(10, decimalPlaces);
    return Math.ceil(num * multiplier + Number.EPSILON) / multiplier;
}
/**
 * Floors a number to specified amount of decimal places.
 *
 * @param num - The number to floor
 * @param decimalPlaces - The number of decimal places to floor to
 * @returns The floored number
 *
 */
function floorToDecimalPlaces(num, decimalPlaces = 0) {
    if (decimalPlaces < 1) {
        return Math.floor(num);
    }
    const multiplier = Math.pow(10, decimalPlaces);
    return Math.floor(num * multiplier + Number.EPSILON) / multiplier;
}
//# sourceMappingURL=roundToDecimalPlaces.js.map